var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size lg_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:" },
            on: { click: _vm.btnClose }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _vm.isLoading
          ? _c(
              "dl",
              {
                staticClass: "modal_content",
                staticStyle: {
                  height: "300px",
                  "line-height": "150px",
                  "text-align": "center"
                }
              },
              [_vm._v("\n                please wait...\n            ")]
            )
          : _c("dl", { staticClass: "modal_content" }, [
              _c("dt", { staticClass: "ellipsis maintit" }, [
                _c("i", [_vm._v(_vm._s(_vm.$t("FIELD.KNOWLEDGE.SEE.DETAILS")))])
              ]),
              _vm._v(" "),
              _c("dd", [
                _c("div", { staticClass: "view_cont" }, [
                  _c("dl", { staticClass: "view_subject" }, [
                    _c("dt", { staticClass: "subject" }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.view.title) +
                          "\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("dd", { staticClass: "desc" }, [
                      _c("span", { staticClass: "desc_Regist" }, [
                        _c("em", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.REGISTERED.BY")))
                        ]),
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.view.reg_user_id) +
                            " (" +
                            _vm._s(_vm.view.reg_dt) +
                            ")\n                                "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "view_desc" }, [
                    _c("div", { staticClass: "sub_tit" }, [
                      _vm._v("Basic Info.")
                    ]),
                    _vm._v(" "),
                    _c("table", { staticClass: "create_table" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("tbody", [
                        _c("tr", [
                          _c("th", [_vm._v("Date")]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.view.reg_dt))]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Register")]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.view.reg_user_id))])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", [_vm._v("Type")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.view.type1) +
                                " / " +
                                _vm._s(_vm.view.type2)
                            )
                          ]),
                          _vm._v(" "),
                          _c("th"),
                          _vm._v(" "),
                          _c("th")
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", [_vm._v("Urgency")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm.view.urgency_yn === "Y"
                              ? _c(
                                  "label",
                                  {
                                    class: {
                                      txt_red: _vm.view.urgency_yn === "Y"
                                    }
                                  },
                                  [_vm._v("Urgent")]
                                )
                              : _c("label", [_vm._v("Normal")])
                          ]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Need Translation")]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "label",
                              {
                                class: {
                                  txt_red: _vm.view.need_reprocess === "Y"
                                }
                              },
                              [_vm._v(_vm._s(_vm.view.need_reprocess))]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", [_vm._v("Required Translations")]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "txt_red", attrs: { colspan: "3" } },
                            [_vm._v(_vm._s(_vm.view.tran))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", [_vm._v("Title")]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm._v(_vm._s(_vm.view.title))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", [_vm._v("Tag Info")]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _vm._v(_vm._s(_vm.view.tag_info))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", [_vm._v("User Level")]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _c(
                              "ul",
                              { staticClass: "ul_list max_scrollbar" },
                              _vm._l(_vm.userLevelList, function(level) {
                                return _c(
                                  "li",
                                  {
                                    key: level.CODE_ID,
                                    staticClass: "userlevel_txt"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(level.CODE_ID) +
                                        " (" +
                                        _vm._s(level.CODE_NAME) +
                                        ")"
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", [_vm._v("Country / Region")]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _c(
                              "ul",
                              { staticClass: "ul_list max_scrollbar" },
                              _vm._l(_vm.countryList, function(country) {
                                return _c(
                                  "li",
                                  {
                                    key: country,
                                    staticClass: "userlevel_txt"
                                  },
                                  [_vm._v(_vm._s(country))]
                                )
                              }),
                              0
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", [_vm._v("Contents")]),
                          _vm._v(" "),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.view.content || _vm.getBlankTemplate
                                )
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", [_vm._v("Attachment")]),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "no_padding",
                              attrs: { colspan: "3" }
                            },
                            [
                              _vm.fileList.length > 0
                                ? _c("innorix-download", {
                                    attrs: {
                                      id: _vm.view.seq,
                                      name: _vm.view.seq,
                                      uploadId: _vm.view.seq,
                                      serviceType: "common",
                                      attachList: _vm.fileList
                                    }
                                  })
                                : _c(
                                    "span",
                                    { staticStyle: { "font-style": "italic" } },
                                    [
                                      _vm._v(
                                        "\n                                                No Attachment\n                                            "
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "btn_wrap topLine" }, [
                    _c("div", { staticClass: "btn_right pc_only" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn_white",
                          attrs: { href: "javascript:", title: "" },
                          on: { click: _vm.btnClose }
                        },
                        [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CLOSE")))]
                      )
                    ])
                  ])
                ])
              ])
            ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcb4dfa0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcb4dfa0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/anysvcmobile/svcBulletin/BulletinViewPopup.vue
// module id = tlMe
// module chunks = 0